export default "__VITE_ASSET__wy0tzA9V__"